import type { PropsWithChildren } from "react";
import { useMemo } from "react";

import noop from "lodash/noop";

import { DeepLinkingContext } from "@/hooks/deepLinking/useDeepLinkingContext";

const DeepLinkingProvider = ({ children }: Readonly<PropsWithChildren>) => {
  // on web, "deep links" don't exist as a concept; there are just web links
  const value = useMemo(
    () => ({
      markPostLoginReadyForDeepLinks: noop,
      resetDeepLinkingOnLogout: noop,
    }),
    [],
  );
  return (
    <DeepLinkingContext.Provider value={value}>
      {children}
    </DeepLinkingContext.Provider>
  );
};

export default DeepLinkingProvider;
